import React from "react";
import '../../assets/css/style.css';


const ShopItemsDan = ({ shop }) => {

    const base_url_done = "https://app.doneapp.ir/";

    const copyToClipboard = () => {
      const userInfo = localStorage.getItem("userinfo");
    
      if (userInfo) {
        const parsedUserInfo = JSON.parse(userInfo); // تبدیل رشته به آبجکت
        const prouser = Number(parsedUserInfo.pro_user); // تبدیل مقدار به عدد
    
        if (prouser === 1) { // حالا می‌تونیم از === استفاده کنیم
          navigator.clipboard.writeText(shop.code_takhfif)
            .then(() => alert(`کد ${shop.code_takhfif} کپی شد!`))
            .catch((err) => console.error("خطا در کپی کردن:", err));
        } else {
          alert("جهت دریافت کد تخفیف، حساب خود را ویژه کنید.");
        }
      }
    };
    
    
    

  return (
    <div className="shops-div-4" id="shop-item">
      <div className="shops-div-5">
        <img src={`${base_url_done}${shop.shop_img}`} className="shop-item-1" alt={shop.shop_title} />
      </div>
     
      <div className="shop-item-2">
        <p className="shop-item-3">{shop.shop_title}</p>
        <p className="shop-item-4">{shop.shop_en_title}</p>
        <p className="shop-item-5">{shop.shop_info}</p>

        <button type="button" 
         onClick={copyToClipboard}
        className="shop-item-btn-1">
          دریافت کد تخفیف
        
        </button>

      </div>
    </div>
  );
};

export default ShopItemsDan;
